import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { HelpCenterTranslations } from '@/HelpCenter/ui/helpCenterTranslations'
import {
    OreButton,
    OreStack,
    OreText,
} from '@edenredespana/oreneta'
import { navigationRoutes } from '@/Shared/ui/routers'
import { PlusCricleIcon } from '@/Shared/ui/assets/PlusCircle'

export const TicketDetailFooterClosed = (): JSX.Element => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    return (
        <OreStack
            space="large"
            direction="column"
            placeContent="center"
            placeItems="center"
        >
            <OreText size="text-md" align="center">
                {t(HelpCenterTranslations.ticketDetail.footer.ticketClosed)}
            </OreText>
            <OreButton
                category="primary"
                onClick={() => navigate(navigationRoutes.newTicket)}
                icon={<PlusCricleIcon />}>
                {t(HelpCenterTranslations.ticketDetail.footer.newTicketButton)}
            </OreButton>
        </OreStack>
    )
}
